module.exports = __webpack_public_path__ + "img/ba.c96fe7bf.svg";